module.exports = __webpack_public_path__ + "img/footer-phone.6001f0db.png";